import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      flexGrow: 1,
      backgroundColor: '#fff',
    },
    menuButton: {
      marginRight: 3,
    },
    title: {
      flexGrow: 1,
    },
    hover: {
      '&:hover': {
        color: 'white',
      },
      fontSize: 14,
    },
    navBar: {
      '& .MuiAppBar-root': {
        background: '#101010',
      },
    },
    test: {
      // background: "#f00",
      '& .MuiAccordion-root': {
        background: '#f00',
      },
      '& .MuiAccordionSummary-root': {
        background: '#00f',
      },
    },
  })
);

export default useStyles;
